var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{class:{bordered: _vm.bordered, cartoon: _vm.cartoon},style:(`width:${_vm.realWidth};height:${_vm.realHeight};display: block;`),attrs:{"src":`${_vm.realSrc}`,"fit":_vm.fit,"rounded":"true"}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_vm._t("error")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }